<template>
  <div>
    <nav class="navbar navbar-transparent navbar-absolute">
      <div class="container">
        <div class="navbar-header">
          <button type="button" class="navbar-toggle"
                  data-toggle="collapse"
                  data-target="#navigation"
                  @click="toggleNavbar">
            <span class="sr-only">Toggle navigation</span>
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
          </button>
          <router-link class="navbar-left" to="/">
            <img class="img-responsive hidden-xs" src="static/img/pf-logo.png" alt="Providence First - Trust Company" />
            <img class="img-responsive visible-xs" src="static/img/pf-icon.png" alt="Providence First - Trust Company" />
          </router-link>
        </div>
        <div class="collapse navbar-collapse">
          <ul class="nav navbar-nav navbar-right">
            <li>
              <a href="http://www.providencefirst.com/?page_id=256" target="_blank">About</a>
            </li>
            <li>
              <a href="http://www.providencefirst.com/?page_id=251" target="_blank">Contact</a>
            </li>
          </ul>
        </div>
      </div>
    </nav>

    <div class="wrapper wrapper-full-page">
      <div class="full-page login-page" data-color=""
           data-image="static/img/background/background-7.jpg">
        <!--   you can change the color of the filter page using: data-color="blue | azure | green | orange | red | purple" -->
        <div class="content">
          <div class="container">
            <div class="row">
              <transition name="fade" mode="out-in">
                <router-view></router-view>
              </transition>
            </div>
          </div>
        </div>
        <footer class="footer footer-transparent">
          <div class="container">
            <div class="copyright">
              &copy; <a href="http://www.providencefirst.com/" target="_blank">Providence First Trust Company</a><br>
              <a style="font-size: 90%" href="static/files/PFTC_Online_Portal_Terms_Conditions.pdf" target="_blank">Terms &amp; Conditions</a> | 
              <a style="font-size: 90%" href="static/files/PFTC_Online_Portal_Privacy_Policy.pdf" target="_blank">Privacy Policy</a>
            </div>
          </div>
        </footer>
        <div class="full-page-background" style="background-image: url(static/img/background/background-7.jpg) "></div>
      </div>
    </div>
    <div class="collapse navbar-collapse off-canvas-sidebar">
      <ul class="nav nav-mobile-menu">
        <li>
          <a href="http://www.providencefirst.com/?page_id=256" target="_blank">About</a>
        </li>
        <li>
          <a href="http://www.providencefirst.com/?page_id=251" target="_blank">Contact Us</a>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
  export default {
    methods: {
      toggleNavbar () {
        document.body.classList.toggle('nav-open')
      },
      closeMenu () {
        document.body.classList.remove('nav-open')
        document.body.classList.remove('off-canvas-sidebar')
      }
    },
    beforeDestroy () {
      this.closeMenu()
    }
  }
</script>
<style>
  .fade-enter-active,
  .fade-leave-active {
    transition: opacity .15s
  }

  .fade-enter,
  .fade-leave-to
    /* .fade-leave-active in <2.1.8 */

  {
    opacity: 0
  }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Home/Home.vue